/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type PersonCommunicationSecretStatus = typeof PersonCommunicationSecretStatus[keyof typeof PersonCommunicationSecretStatus];


export const PersonCommunicationSecretStatus = {
  Secret: 'Secret',
  Internal: 'Internal',
  Public: 'Public',
} as const;
